import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { getIsGreaterChinaSalesOrg, getIsShoppingEnabled } from '../../gamedayAccount/selectors';
import ReturnStatusCard from './ReturnStatusCard';
import DateRangeSelector from '../DateRangeSelector';
import StatusToolTip from './StatusToolTip';
import { Button, H1, Link, NoResults } from '../../components/';
import TableInfiniteScroll from '~COMPONENTS/table/TableInfiniteScroll';
import SortOptions from '~COMPONENTS/sortOptions/SortOptions';
import LoadingMessage from '~COMPONENTS/spinner/LoadingMessage';
import StatusSearch from '~COMPONENTS/formInputs/StatusSearch';
import PageHeader from '~COMPONENTS/containers/PageHeader';
import { Filters } from '../../shop/filters/';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { searchKeyOptions, dateRangeOptions, sortOptions } from './selectOptions';
import columns from './columns';

import {
  addReturnsFilter,
  clearReturnsFilters,
  clearReturnsSortBy,
  deleteReturn,
  removeReturnsFilter,
  requestReturns,
  setReturnsFilters,
  updateReturnsDateRange,
  updateReturnsSortBy,
  setReturnsListType,
  setNavNewReturn
} from './actions';
import { setSearchTerm as setGlobalSearchTerm, setSortBy, setSilentSearchTerm } from '../../global/actions';
import { searchTerm as globalSearchTerm, sortBy as globalSortBy, silentSearchTerm } from '../../global/reducer';
import {
  dateRange,
  filterOptions,
  isFetching,
  returnList,
  selectedFilters,
  sortBy,
  getReturnsListType,
  totalRecords
} from './reducer';
import { hasAuthCheckFinished } from '../../auth/reducer';
import { closeModal, openModal } from '../../components/modal/actions';
import { billableDepartments, getUserAccount, selectDepartments } from '../../user/selectors';
import { userDepartments } from '../../user/reducer';
import { setOriginatesFromReturnStatus, setSelectedReturnId } from '../orderReturns/actions';
import { originatesFromReturnStatus } from '../orderReturns/reducer';
import {
  previousLocationWasOrderDetails,
  previousLocationWasReturnStep,
  previousLocationWasReturnDetails
} from '../reducer';

import { mapDepartmentName, mapDepartmentNumbers, updateAllFilters } from '../status/util';
import { DEFAULT_DATE_RANGE, LABEL_SELECT_ALL, RETURN_CODE_UNSUBMITTED, CUSTOM_DATE_RANGE } from '../../shop/constants';

import { dateRangeTypes, filterOptionTypes, sortByTypes } from '../../types/status';
import { departmentsTypes, userAccountTypes, userDepartmentTypes } from '../../types/user';

import {
  ALL_RETURNS,
  DEPT_NAMES_KEY,
  PAGE,
  PAGE_COUNT,
  RETURN_AUTH_ID_KEY,
  sortbyMap,
  UNSUBMITTED_RETURNS,
  DEFAULT_SORT
} from './constants';

class ReturnStatus extends Component {
  constructor(props) {
    super(props);
    const {
      getReturnsListType,
      globalSearchTerm,
      globalSortBy,
      globalSortBy: { field, order }
    } = this.props;
    this.state = {
      hasMore: true,
      initialLoad: true,
      isFilterOpen: false,
      isReturnNumberSearch: false,
      page: 1,
      paginate: false,
      requestQueue: 0,
      returnListType: getReturnsListType && getReturnsListType !== '' ? getReturnsListType : ALL_RETURNS,
      returnsList: [],
      searchKey: RETURN_AUTH_ID_KEY,
      searchTerm: globalSearchTerm && globalSearchTerm !== '' ? globalSearchTerm : '',
      selectAllToggle: false,
      showClearFilters: !!(
        (globalSearchTerm && globalSearchTerm !== '') ||
        (globalSortBy && field !== '' && order !== '')
      ),
      showClearAll: !!((globalSearchTerm && globalSearchTerm !== '') || (globalSortBy && field !== '' && order !== '')),
      paramCache: null
    };
  }

  async componentDidMount() {
    const {
      globalSortBy,
      originatesFromReturnStatus,
      previousLocationWasOrderDetails,
      previousLocationWasReturnDetails,
      previousLocationWasReturnStep,
      setNavNewReturn,
      setOriginatesFromReturnStatus,
      setSilentSearchTerm,
      setSortBy,
      silentSearchTerm,
      userAccount
    } = this.props;

    if (!userAccount || !userAccount.number) {
      return;
    }

    if (
      silentSearchTerm !== '' ||
      (!previousLocationWasOrderDetails &&
        !previousLocationWasReturnStep &&
        !previousLocationWasReturnDetails &&
        !originatesFromReturnStatus)
    ) {
      await this.clearSearchAndFilters();
    }
    if (previousLocationWasReturnDetails || previousLocationWasReturnStep) {
      await this.filterList();
    } else {
      await this.clearSearchAndFilters();
      await this.fetchReturnsRequest();
    }
    this.setFilterOptions();
    this.resetForm();
    // --
    setOriginatesFromReturnStatus(true);
    setSilentSearchTerm('');
    setReturnsListType('');
    setNavNewReturn(false);

    if (globalSortBy && (!globalSortBy.page || globalSortBy.page === '')) {
      setSortBy({ ...globalSortBy, page: PAGE });
    } else setSortBy({ ...DEFAULT_SORT });
  }

  async componentDidUpdate(prevProps, prevState) {
    const { userAccount, hasAuthCheckFinished } = this.props;
    const { requestQueue } = this.state;
    const { requestQueue: prevrequestQueue } = prevState;
    if (hasAuthCheckFinished && userAccount && prevProps.userAccount.number !== userAccount.number) {
      // User switched Sold-to
      await this.clearSearchAndFilters();
      this.setFilterOptions();
      this.fetchReturnsRequest();
    } else if (prevrequestQueue !== requestQueue && requestQueue === 0) {
      this.filterList();
    }
  }

  componentWillUnmount() {
    const { searchTerm, returnListType } = this.state;
    const { setGlobalSearchTerm, setSortBy, sortBy, setReturnsListType } = this.props;
    setGlobalSearchTerm(searchTerm);
    setSortBy({ ...sortBy, page: PAGE });
    setReturnsListType(returnListType);
  }

  setSearchTerm = val => this.setState({ searchTerm: val });

  setSearchKey = async ({ value }) => {
    await this.clearSearchAndFilters();

    const { change } = this.props;
    change('returnStatus__search__input', '');
    change('returnStatus__search__searchKey', value);
    this.setState({ searchKey: value, searchTerm: '' });
  };

  setFilterOptions = () => {
    const {
      setReturnsFilters,
      updateReturnsSortBy,
      globalSortBy: { field, order },
      userDepartments: { deptNames }
    } = this.props;
    if (field !== '' && order !== '') updateReturnsSortBy({ field: field, order: order });
    setReturnsFilters({ key: DEPT_NAMES_KEY, values: deptNames });
  };

  setReturnsList = returns => {
    if (!returns) return;

    const { returnsList, page } = this.state;
    this.setState({
      returnsList: page > 1 ? [...returnsList, ...returns] : returns,
      initialLoad: false
    });
  };

  setReturnsListType = returnListType => this.setState({ returnListType }, () => this.fetchReturnsRequest());

  incrementRequestQueue = () => {
    const { requestQueue } = this.state;
    return this.setState({ requestQueue: requestQueue + 1 });
  };

  sortOptionsRef = React.createRef();

  sortOptionsRefDesktop = React.createRef();

  fetchReturnsRequest = (additionalParams = {}) => {
    let { paramCache } = this.state;
    if (Object.keys(additionalParams).length === 0) paramCache = {};

    const { requestQueue, returnListType } = this.state;
    const {
      isFetching,
      sortBy,
      dateRange,
      silentSearchTerm,
      userAccount: { number }
    } = this.props;

    if (isFetching) {
      this.incrementRequestQueue();
    } else if (requestQueue === 0) {
      paramCache = {
        accountNumber: number,
        dateRange:
          dateRange && dateRange.startDate && dateRange.endDate
            ? {
                startDate: dateRange.startDate.replace(/\//g, '-'),
                endDate: dateRange.endDate.replace(/\//g, '-'),
                period: CUSTOM_DATE_RANGE
              }
            : dateRange,
        sort: sortBy
          ? {
              ...sortBy,
              field: sortBy.field === 'orderSubmittedDate' ? DEFAULT_SORT.field : sortBy.field
            }
          : null,
        page: {
          number: 1,
          size: PAGE_COUNT
        },
        ...additionalParams
      };
      if (returnListType === UNSUBMITTED_RETURNS) {
        paramCache.returnStatuses = [RETURN_CODE_UNSUBMITTED];
      }
      if (silentSearchTerm !== '') {
        paramCache.gamedayOrderIds = [silentSearchTerm];
      }

      this.setState({ paramCache }, () => this.fetchReturns());
    }
  };

  fetchReturns = async () => {
    const { paramCache, initialLoad } = this.state;
    const {
      requestReturns,
      billableDepartments,
      departments,
      userAccount: { number }
    } = this.props;

    return requestReturns(paramCache).then(async ({ payload: { returns } }) => {
      const returnsWithDeptNames =
        returns && returns.length
          ? await mapDepartmentName(
              returns,
              [...billableDepartments, ...departments],
              billableDepartments.length > 0 ? [number, billableDepartments[0].customerNumber] : [number]
            )
          : [];

      this.setState({
        hasMore:
          returnsWithDeptNames && returnsWithDeptNames.length ? returnsWithDeptNames.length === PAGE_COUNT : false,
        paginate: false,
        requestQueue: 0
      });
      if (initialLoad) this.setFilterOptions();
      return this.setReturnsList(returnsWithDeptNames);
    });
  };

  loadInfiniteScrollOrders = async () => {
    // Limiting issues around multiple calls (one for table and one for cards)
    // Not my favorite solve, but I couldn't seem to limit with a debounce
    setTimeout(() => {
      const { isFetching } = this.props;
      const { page, hasMore } = this.state;
      if (hasMore && !isFetching) {
        this.setState({ page: page + 1, hasMore: true, paginate: true }, () => this.filterList());
      }
    }, 250);
  };

  filterList = () => {
    const { searchTerm, searchKey, page, paginate, returnListType } = this.state;
    const { selectedFilters, userDepartments } = this.props;
    const additionalParams = {
      page: {
        number: 1,
        size: PAGE_COUNT
      }
    };
    const departmentNamesList = Array.from(selectedFilters.get(DEPT_NAMES_KEY));
    const creditTypes = Array.from(selectedFilters.get('creditType'));
    const returnStatus = Array.from(selectedFilters.get('returnStatus'));

    if (departmentNamesList.length) {
      additionalParams.departments = mapDepartmentNumbers(departmentNamesList, userDepartments.depts);
    }
    if (creditTypes.length) {
      additionalParams.creditTypes = creditTypes.map(type => type.split('.').join('-').toUpperCase());
    }
    if (returnStatus.length) {
      additionalParams.returnStatuses = returnStatus;
    }
    if (returnListType === UNSUBMITTED_RETURNS) {
      additionalParams.returnStatuses = [UNSUBMITTED_RETURNS];
    }

    if (searchTerm && searchKey) {
      additionalParams[searchKey] = [searchTerm];
    }

    if (paginate) {
      additionalParams.page.number = page;
    } else {
      this.setState({ page: 1 });
    }

    this.setState({
      showClearFilters: Object.keys(additionalParams).length > 1 || departmentNamesList.length > 0,
      requestQueue: 0
    });

    return this.fetchReturnsRequest(additionalParams);
  };

  handleListSort = async ({ value, desc }) => {
    const { sortBy, updateReturnsSortBy } = this.props;
    const isDesc = desc ? 'DESC' : 'ASC';
    const updatedSort = { field: value, order: isDesc };

    if (sortBy !== updatedSort) {
      await updateReturnsSortBy(updatedSort);
      this.filterList();
    }
  };

  handleSelection = async (name, isChecked) => {
    const { selectAllToggle } = this.state;
    const { addReturnsFilter, filterOptions, removeReturnsFilter } = this.props;
    // --
    const [key, value] = name.split('--');

    await this.resetPage();
    this.incrementRequestQueue();

    if (name === LABEL_SELECT_ALL) {
      await updateAllFilters(addReturnsFilter, removeReturnsFilter, filterOptions, DEPT_NAMES_KEY, !selectAllToggle);
      this.setState({ selectAllToggle: !selectAllToggle });
      this.filterList();
      return;
    }
    if (isChecked) {
      this.setState({ showClearAll: true });
      await addReturnsFilter({ key, value });
    } else {
      this.setState({ selectAllToggle: false });
      await removeReturnsFilter({ key, value });
    }

    this.filterList(value, key);
  };

  handleDeleteClick = (returnId, e) => {
    e.stopPropagation();

    const { closeModal, openModal } = this.props;
    openModal({
      type: 'alert',
      title: new TranslatedCopy({ id: 'returnStatus.modal.delete.title' }).toString(),
      confirmText: new TranslatedCopy({ id: 'global.confirm' }).toString(),
      confirmAction: () => this.handleDeleteAcceptClick(returnId),
      cancelText: new TranslatedCopy({ id: 'global.cancel' }).toString(),
      cancelAction: closeModal
    });
  };

  handleDeleteAcceptClick = returnId => {
    const { closeModal, deleteReturn } = this.props;
    deleteReturn({ returnId }).then(() => {
      closeModal();
      this.resetPage();
      this.filterList();
    });
  };

  handleStatusDetailsClick = e => {
    const { openModal } = this.props;
    openModal({
      title: <TranslatedCopy id='returnStatus.returnStatus.details.title' />,
      type: 'tooltip',
      element: e.target,
      noPadding: true,
      content: <StatusToolTip />
    });
  };

  clearSearch = async () => {
    const { searchTerm } = this.state;
    if (searchTerm) {
      await this.setState({ searchTerm: '', showClearFilters: false, isReturnNumberSearch: false, page: 1 });
    }
    return this.filterList();
  };

  clearOnlyFilters = async () => {
    const { clearReturnsFilters } = this.props;
    const { searchTerm } = this.state;
    await clearReturnsFilters();
    this.setState(
      {
        showClearFilters: false,
        page: 1,
        showClearAll: searchTerm !== ''
      },
      () => {
        this.fetchReturnsRequest();
      }
    );
  };

  handleFilterClick = () => {
    const { isFilterOpen } = this.state;
    this.setState({ isFilterOpen: !isFilterOpen });
  };

  clearSearchAndFilters = async () => {
    const { clearReturnsSortBy, clearReturnsFilters, updateReturnsDateRange } = this.props;
    const { initialLoad } = this.state;
    await clearReturnsFilters();
    await clearReturnsSortBy();

    this.resetForm();
    if (
      this.sortOptionsRef &&
      this.sortOptionsRef.current &&
      this.sortOptionsRefDesktop &&
      this.sortOptionsRefDesktop.current
    ) {
      this.sortOptionsRef.current.resetOptions();
      this.sortOptionsRefDesktop.current.resetOptions();
    }

    updateReturnsDateRange({
      period: DEFAULT_DATE_RANGE,
      startDate: null,
      endDate: null
    });

    this.setState({
      searchKey: RETURN_AUTH_ID_KEY,
      searchTerm: '',
      showClearFilters: false,
      showClearAll: false,
      isReturnNumberSearch: false,
      page: 1
    });
    if (!initialLoad) {
      this.fetchReturnsRequest();
    }
  };

  resetPage = () => {
    this.setState({ page: 1 });
  };

  resetForm = () => {
    const { change } = this.props;
    change('returnStatus__search__input', '');
    change('returnStatus__search__searchKey', RETURN_AUTH_ID_KEY);
    this.setState({ showClearAll: false, showClearFilters: false, page: 1 });
  };

  handleReturnClick = (selectedReturn, e) => {
    e.preventDefault();

    const { setSelectedReturnId, history } = this.props;
    const { returnsList } = this.state;
    const currReturn = returnsList.filter(rtn =>
      selectedReturn.id ? rtn.id === selectedReturn.id : rtn.returnId === selectedReturn.returnId
    )[0];
    if (!currReturn) return;

    setSelectedReturnId(currReturn.returnId);
    if (currReturn.returnStatus === RETURN_CODE_UNSUBMITTED) {
      // Unsubmitted Return -> Return Steps
      history.push(`/orders/returns/id/${currReturn.orderId}`);
    } else {
      // Submitted Return -> Return Details
      history.push(`/orders/returns/details/id/${currReturn.id}`);
    }
  };

  handleDateChange = dateRange => {
    const { updateReturnsDateRange } = this.props;
    this.setState({ showClearAll: dateRange.period !== DEFAULT_DATE_RANGE });
    updateReturnsDateRange(dateRange);
  };

  submitSearch = () => {
    const { searchKey, searchTerm } = this.state;
    if (searchTerm.length < 3) {
      return null;
    }
    const searchParams = { [searchKey]: [searchTerm] };
    this.setState({ showClearAll: true, showClearFilters: true, page: 1 });

    if (searchKey === RETURN_AUTH_ID_KEY && searchTerm) {
      return this.setState({ isReturnNumberSearch: true }, () => this.fetchReturnsRequest(searchParams));
    }
    return this.setState({ isReturnNumberSearch: false }, () => this.filterList(searchParams));
  };

  beginReturn = async e => {
    e.preventDefault();
    // --
    const { setNavNewReturn, history } = this.props;
    await setNavNewReturn(true);
    history.push('/orders/status');
  };

  render() {
    let filteredReturnsList;

    const {
      hasMore,
      initialLoad,
      isFilterOpen,
      isReturnNumberSearch,
      paginate,
      returnListType,
      returnsList,
      selectAllToggle,
      showClearFilters,
      showClearAll,
      paramCache
    } = this.state;
    const {
      change,
      dateRange,
      filterOptions,
      globalSortBy,
      isFetching,
      isGreaterChinaSalesOrg,
      selectedFilters,
      totalRecords,
      isShoppingEnabled
    } = this.props;

    filteredReturnsList = returnsList;

    const defaultSortBy =
      globalSortBy && globalSortBy.page === PAGE && globalSortBy.field !== '' && globalSortBy.order !== ''
        ? {
            value: globalSortBy.field,
            name: sortbyMap.get(globalSortBy.field),
            desc: globalSortBy.order === 'DESC'
          }
        : {
            value: DEFAULT_SORT.field,
            name: new TranslatedCopy({ id: 'returnStatus.orderSubmittedDate' }).toString(),
            desc: true
          };

    const filteredFilterOptions =
      returnListType === UNSUBMITTED_RETURNS
        ? filterOptions.filter(option => option.key !== 'returnStatus')
        : filterOptions;

    // If related-returns result, filter out unsubmitted records
    if (paramCache && paramCache.gamedayOrderIds && paramCache.gamedayOrderIds.length > 0) {
      filteredReturnsList = filteredReturnsList.filter(ret => ret.isSubmitted);
    }

    return (
      <div className='returnStatus'>
        <div className='status__main_outerWrapper'>
          <PageHeader
            page='returnStatus'
            title={
              <>
                <span className='mr5-lg'>
                  <TranslatedCopy id='returnStatus.route' />
                </span>
                <div className='d-sm-b d-md-ib'>
                  {!isFetching && (
                    <div className='returnStatus__searchResults body-4 mt1-sm'>
                      <div className='mr3-sm' data-desc='returnStatus__search_count'>
                        <TranslatedCopy id='orderstatus.header.result' values={{ amount: totalRecords || 0 }} />
                      </div>
                      {showClearAll && (
                        <Button
                          className='text-color-secondary body-4 u-underline fl-sm-r pt0-sm pb0-sm'
                          data-desc='returnStatus__search_clear'
                          useBareClass
                          textLink
                          onClick={this.clearSearchAndFilters}
                        >
                          <TranslatedCopy id='orderstatus.search.clear' />
                        </Button>
                      )}
                    </div>
                  )}
                  <div className='d-sm-ib d-md-h'>
                    <Link
                      to='/'
                      extraClassName='body-4 text-color-secondary ncss-base u-capitalize'
                      data-desc='returnStatus__start_mobile'
                      onClick={this.beginReturn}
                    >
                      <TranslatedCopy id='global.beginReturn' />
                    </Link>
                  </div>
                </div>
                <div>
                  {isShoppingEnabled && (
                    <Link
                      to='/'
                      extraClassName='body-4 text-color-secondary ncss-base d-sm-h d-md-ib u-capitalize'
                      data-desc='returnStatus__start_desktop'
                      onClick={this.beginReturn}
                    >
                      <TranslatedCopy id='global.beginReturn' />
                    </Link>
                  )}
                </div>
              </>
            }
            className={classnames('flex-container row bg-white align-center', { hasResults: showClearFilters })}
          >
            <div className='flex-container row center space-between'>
              <div className='status__main_menu u-full-height flex-container row align-center'>
                <Button
                  onClick={() => this.setReturnsListType(ALL_RETURNS)}
                  className={classnames('body-3 p0-sm d-sm-ib mr4-sm', {
                    selected: returnListType === ALL_RETURNS
                  })}
                >
                  <TranslatedCopy id='returnStatus.header.allReturns' />
                </Button>
                {isShoppingEnabled && (
                  <Button
                    onClick={() => this.setReturnsListType(UNSUBMITTED_RETURNS)}
                    className={classnames('body-3 p0-sm d-sm-ib', {
                      selected: returnListType === UNSUBMITTED_RETURNS
                    })}
                  >
                    <TranslatedCopy id='returnStatus.header.unsubmitted' />
                  </Button>
                )}
              </div>

              <div className='status__search_container_desktop d-sm-h d-lg-ib'>
                <StatusSearch
                  onSubmit={this.submitSearch}
                  name='returnStatus__search'
                  clearSearch={this.clearSearch}
                  searchKeyOptions={searchKeyOptions}
                  setSearchTerm={this.setSearchTerm}
                  setSearchKey={this.setSearchKey}
                  change={change}
                />
              </div>
            </div>
          </PageHeader>
          <div className='status__search_container_mobile d-lg-h bg-white pt4-sm prl3-sm mt12-sm'>
            <StatusSearch
              onSubmit={this.submitSearch}
              name='returnStatus__search'
              clearSearch={this.clearSearch}
              searchKeyOptions={searchKeyOptions}
              setSearchTerm={this.setSearchTerm}
              setSearchKey={this.setSearchKey}
              change={change}
            />
          </div>
          <div className='d-sm-b d-lg-h'>
            <div className='flex-container row space-between bg-white p4-sm'>
              <Button onClick={this.handleFilterClick}>
                <TranslatedCopy id='global.filter' />
              </Button>
              <SortOptions
                ref={this.sortOptionsRef}
                list={filteredReturnsList}
                sortBy={sortOptions}
                defaultValue={defaultSortBy}
                handleExternalSort={this.handleListSort}
              />
            </div>
          </div>

          {!isReturnNumberSearch && (
            <div
              className={classnames('status__filters order-status-item pl8-md pr4-md flex-container', {
                isOpen: isFilterOpen
              })}
            >
              <Filters
                filters={initialLoad ? [] : filteredFilterOptions}
                onChange={this.handleSelection}
                selected={selectedFilters}
                selectAll={selectAllToggle}
                pageName='returnStatus'
                showFilterCount
                closeOnOutsideClick
                isTranslated
              />

              {showClearFilters && (
                <div className='order-status-item flex-container row'>
                  <div className='filters__clear body-4'>
                    <Button
                      className='text-color-secondary body-4 p0-sm u-underline fl-sm-r  '
                      data-desc='gridwall__filter_clear'
                      useBareClass
                      textLink
                      onClick={this.clearOnlyFilters}
                    >
                      <TranslatedCopy id='orderstatus.filters.clear' />
                    </Button>
                  </div>
                </div>
              )}
              <DateRangeSelector
                dateRange={dateRange}
                dateRangeOptions={dateRangeOptions}
                updateDateRange={this.handleDateChange}
                resetPage={this.resetPage}
                filterList={this.filterList}
              />
              <div className='d-sm-h d-lg-b flex-expand'>
                <SortOptions
                  ref={this.sortOptionsRefDesktop}
                  list={filteredReturnsList}
                  sortBy={sortOptions}
                  defaultValue={defaultSortBy}
                  handleExternalSort={this.handleListSort}
                />
              </div>
            </div>
          )}

          <div className='status__filters_bg' onClick={this.handleFilterClick} />
          <div className='p5-sm'>
            {isFetching && <LoadingMessage title={new TranslatedCopy({ id: 'global.results' }).toString()} />}
            {!isFetching && filteredReturnsList.length === 0 && !isReturnNumberSearch && (
              <NoResults titleId='returnStatus.search.advanced.noresults.title'>
                <div className='status__search_noResults'>
                  <p className='mt5-sm mb3-sm'>
                    <TranslatedCopy id='returnStatus.search.advanced.noresults.copy' />
                  </p>
                </div>
              </NoResults>
            )}
            {!isFetching && filteredReturnsList.length === 0 && showClearAll && isReturnNumberSearch && (
              <div className='mt12-sm mb12-sm ta-sm-c'>
                <H1>
                  <TranslatedCopy id='returnStatus.search.simple.noresults.title' />
                </H1>
                <div className='status__search_noResults'>
                  <p className='mt5-sm mb3-sm'>
                    <TranslatedCopy id='returnStatus.search.simple.noresults.copy' />
                  </p>
                </div>
              </div>
            )}
            {((filteredReturnsList && filteredReturnsList.length > 0 && !isFetching) || (paginate && isFetching)) && (
              <>
                <div className='table-view body-4 pb4-md d-sm-h d-lg-b'>
                  <TableInfiniteScroll
                    data={filteredReturnsList}
                    columns={columns}
                    loadMore={this.loadInfiniteScrollOrders}
                    hasMore={hasMore}
                    clickTarget={null}
                    handleClick={this.handleReturnClick}
                    cellProps={{
                      handleDeleteClick: this.handleDeleteClick
                    }}
                    headerProps={{
                      handleStatusDetailsClick: this.handleStatusDetailsClick
                    }}
                    isGreaterChinaSalesOrg={isGreaterChinaSalesOrg}
                  />
                </div>
                <div className='d-lg-h'>
                  {filteredReturnsList.map(returnStatus => (
                    <ReturnStatusCard
                      key={`returnCard__${returnStatus.returnId}`}
                      returnData={returnStatus}
                      handleClick={this.handleReturnClick}
                      handleStatusDetailsClick={this.handleStatusDetailsClick}
                      handleDeleteClick={this.handleDeleteClick}
                    />
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

ReturnStatus.propTypes = {
  addReturnsFilter: PropTypes.func.isRequired,
  billableDepartments: departmentsTypes,
  change: PropTypes.func.isRequired,
  clearReturnsFilters: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  dateRange: dateRangeTypes.isRequired,
  deleteReturn: PropTypes.func.isRequired,
  departments: departmentsTypes,
  filterOptions: filterOptionTypes,
  history: ReactRouterPropTypes.history.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isGreaterChinaSalesOrg: PropTypes.bool.isRequired,
  isShoppingEnabled: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  removeReturnsFilter: PropTypes.func.isRequired,
  requestReturns: PropTypes.func.isRequired,
  selectedFilters: PropTypes.any.isRequired,
  setReturnsFilters: PropTypes.func.isRequired,
  sortBy: sortByTypes.isRequired,
  updateReturnsDateRange: PropTypes.func.isRequired,
  updateReturnsSortBy: PropTypes.func.isRequired,
  userAccount: userAccountTypes,
  userDepartments: userDepartmentTypes,
  setGlobalSearchTerm: PropTypes.func.isRequired,
  setSortBy: PropTypes.func.isRequired,
  globalSearchTerm: PropTypes.string,
  silentSearchTerm: PropTypes.string,
  setSilentSearchTerm: PropTypes.func.isRequired,
  globalSortBy: sortByTypes.isRequired,
  setOriginatesFromReturnStatus: PropTypes.func.isRequired,
  originatesFromReturnStatus: PropTypes.bool.isRequired,
  previousLocationWasOrderDetails: PropTypes.bool.isRequired,
  previousLocationWasReturnStep: PropTypes.bool.isRequired,
  previousLocationWasReturnDetails: PropTypes.bool.isRequired,
  setReturnsListType: PropTypes.func.isRequired,
  getReturnsListType: PropTypes.string.isRequired,
  setSelectedReturnId: PropTypes.func.isRequired,
  totalRecords: PropTypes.number,
  hasAuthCheckFinished: PropTypes.bool.isRequired,
  clearReturnsSortBy: PropTypes.func.isRequired,
  setNavNewReturn: PropTypes.func.isRequired
};

ReturnStatus.defaultProps = {
  billableDepartments: null,
  departments: null,
  filterOptions: null,
  userAccount: null,
  userDepartments: null,
  globalSearchTerm: '',
  silentSearchTerm: '',
  totalRecords: 0
};

const mapStateToProps = state => ({
  billableDepartments: billableDepartments(state),
  dateRange: dateRange(state),
  departments: selectDepartments(state),
  filterOptions: filterOptions(state),
  hasAuthCheckFinished: hasAuthCheckFinished(state),
  isFetching: isFetching(state),
  isGreaterChinaSalesOrg: getIsGreaterChinaSalesOrg(state),
  isShoppingEnabled: getIsShoppingEnabled(state),
  returnList: returnList(state),
  selectedFilters: selectedFilters(state),
  sortBy: sortBy(state),
  userAccount: getUserAccount(state),
  userDepartments: userDepartments(state),
  globalSearchTerm: globalSearchTerm(state),
  silentSearchTerm: silentSearchTerm(state),
  globalSortBy: globalSortBy(state),
  originatesFromReturnStatus: originatesFromReturnStatus(state),
  previousLocationWasOrderDetails: previousLocationWasOrderDetails(state),
  previousLocationWasReturnStep: previousLocationWasReturnStep(state),
  previousLocationWasReturnDetails: previousLocationWasReturnDetails(state),
  getReturnsListType: getReturnsListType(state),
  totalRecords: totalRecords(state)
});

const connector = connect(mapStateToProps, {
  addReturnsFilter,
  clearReturnsFilters,
  clearReturnsSortBy,
  closeModal,
  deleteReturn,
  openModal,
  removeReturnsFilter,
  requestReturns,
  setReturnsFilters,
  updateReturnsDateRange,
  updateReturnsSortBy,
  setGlobalSearchTerm,
  setSortBy,
  setOriginatesFromReturnStatus,
  setSilentSearchTerm,
  setReturnsListType,
  setSelectedReturnId,
  setNavNewReturn
});

export default reduxForm({
  form: 'returnStatusForm'
})(connector(ReturnStatus));
